import React, { useState, useEffect } from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';
import { useHistory, useLocation } from 'react-router-dom';
import css from './TransactionSearch.module.css';

const TransactionSearch = props => {
  const { placeholder, className, rootClassName } = props;
  const history = useHistory();
  const location = useLocation();

  // Extract initial keywords from URL
  const searchParams = new URLSearchParams(location.search);
  const initialKeywords = searchParams.get('search') || '';

  const [keywords, setKeywords] = useState(initialKeywords);
  const [lastPushed, setLastPushed] = useState(initialKeywords);

  // Sync state with URL if URL changes externally
  useEffect(() => {
    const currentParams = new URLSearchParams(location.search);
    const currentKeywords = currentParams.get('search') || '';
    if (currentKeywords !== lastPushed) {
      setKeywords(currentKeywords);
      setLastPushed(currentKeywords);
    }
  }, [location.search, lastPushed]);

  // Normalize search keywords: lowercase, remove /, comma, quotes
  const normalizeSearchKeywords = (text) => {
    return text
      .toLowerCase()
      .replace(/[\,\/"]/g, '');
  };

  // Debounced update to history
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      const currentParams = new URLSearchParams(location.search);
      const currentKeywords = currentParams.get('search') || '';
      const normalizedKeywords = normalizeSearchKeywords(keywords);
      
      if (normalizedKeywords !== currentKeywords) {
        if (normalizedKeywords) {
          currentParams.set('search', normalizedKeywords);
        } else {
          currentParams.delete('search');
        }
        setLastPushed(normalizedKeywords);
        history.push({
          pathname: location.pathname,
          search: '?' + currentParams.toString(),
        });
      }
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [keywords, history, location.pathname, location.search]);

  const onChange = e => {
    setKeywords(e.target.value);
  };

  const classes = classNames(rootClassName || css.searchContainer, className);

  return (
    <div className={classes}>
      <div className={css.searchField}>
        <svg
          className={css.searchFieldIcon}
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <circle cx="11" cy="11" r="7" />
          <line x1="21" y1="21" x2="16.65" y2="16.65" />
        </svg>
        <input
          type="search"
          placeholder={placeholder}
          className={css.searchInput}
          value={keywords}
          onChange={onChange}
          aria-label={placeholder}
        />
      </div>
    </div>
  );
};

TransactionSearch.defaultProps = {
  placeholder: 'Sök',
  className: null,
  rootClassName: null,
};

TransactionSearch.propTypes = {
  placeholder: string,
  className: string,
  rootClassName: string,
};

export default TransactionSearch;
